__turbopack_context__.v({
  "details": "ProjectTeaserHorizontal-module-scss-module__RBrhlq__details",
  "inner": "ProjectTeaserHorizontal-module-scss-module__RBrhlq__inner",
  "preview": "ProjectTeaserHorizontal-module-scss-module__RBrhlq__preview",
  "recentBadge": "ProjectTeaserHorizontal-module-scss-module__RBrhlq__recentBadge",
  "withLatestMessage": "ProjectTeaserHorizontal-module-scss-module__RBrhlq__withLatestMessage",
  "withoutMeta": "ProjectTeaserHorizontal-module-scss-module__RBrhlq__withoutMeta",
  "wrapper": "ProjectTeaserHorizontal-module-scss-module__RBrhlq__wrapper",
});
